const en = {
  // Navigation
  'nav.daily_video': 'Daily',
  'nav.qna_video': 'Q&A',
  'nav.growth_record': 'Growth',
  'nav.cancel': 'Cancel',
  'nav.talent_analysis': 'Analyze',
  'nav.home': 'Home',
  'nav.report': 'Report',
  'nav.education': 'Custom.Ed',
  'nav.my': 'My',
  'nav.alert.analysis_in_progress.title': 'A video is currently being analyzed!',
  'nav.alert.analysis_in_progress.description': 'Analysis is in progress.\nPlease try again after the current analysis is complete.',
  'nav.alert.no_report.title': 'Report cannot be viewed!',
  'nav.alert.no_report.description': 'No report exists yet. Analyze your child’s video and check the report.',
  'nav.alert.no_report.btn': 'Analyze Video',
  'nav.alert.video_limit.title': 'Cannot upload more videos',
  'nav.alert.video_limit.description': 'All 12 videos are registered.\nPlease proceed according to the cases below.',
  'nav.alert.video_limit.step1_title': 'Complete 8 Multi-intelligence Reports',
  'nav.alert.video_limit.step1_desc': 'Delete existing video → Add new video',
  'nav.alert.video_limit.step2_title': 'Start with a new report',
  'nav.alert.video_limit.step2_desc': "Click 'Create New Report' button\nin the more menu at the top right of the report",

  // Common
  'common.confirm': 'Confirm',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.next': 'Next',
  'common.register': 'Post',
  'common.comment_placeholder': 'Leave a comment.',
  'common.agree': 'Agree',
  'common.done': 'Done',
  'common.qna': 'Q&A',
  'common.report_abuse': 'Report',
  'common.general': 'Average',
  'common.age': '{{age}} years old',
  'common.month': 'Month {{month}}',
  'common.date_format': '{{month}}/{{day}}',
  'common.sort_registration': 'By Registration',
  'common.sort_latest': 'Latest',
  'common.toast_delete_comment_fail': 'Failed to delete comment.',
  'common.toast_delete_post_fail': 'Failed to delete post.',
  'common.toast_load_fail': 'Failed to load data.',
  'common.loading': 'Loading...',
  'common.time.just_now': 'Just now',
  'common.time.minutes_ago': '{{count}}m ago',
  'common.time.hours_ago': '{{count}}h ago',
  'common.time.days_ago': '{{count}}d ago',

  // Login & Register
  'login.title_line1': 'Understanding our child',
  'login.title_line2': 'AI Report, Onkids',
  'login.subtitle': "Discovering your child's talent in everyday videos",
  'login.kakao': 'Start with KakaoTalk',
  'login.pass': 'Start with PASS',
  'login.kakao_simple': 'KakaoTalk',
  'login.pass_simple': 'PASS',
  'login.pass.title_edit': 'Please verify your identity\nto edit your information.',
  'login.pass.title_signup': 'Identity verification is required\nto join Onkids!',
  'login.pass.subtitle': 'Verification is required for security.',
  'login.pass.temp_signup': '(Temp Sign-up for Local)',
  'login.pass.btn_pass': 'Verify with PASS',
  'login.pass.btn_kakao': 'Verify with KakaoTalk',
  'login.pass.footer': 'You can use the service normally\nafter identity verification.',
  'login.pass.temp_signup_btn': 'Temporary Sign-up',
  'login.pass.temp_signup_toast': 'Insufficient info for local temporary sign-up.',
  'login.pass.alert_already_title': 'Already registered account',
  'login.pass.alert_already_desc': 'You have already logged in with {{type}}.\nPlease proceed with {{type}} login.',
  'login.pass.alert_already_btn': '{{type}} Login',
  'login.pass.toast_popup_blocked': 'Pop-up is blocked. Please allow pop-ups.',
  'login.pass.toast_kakao_mobile': 'KakaoTalk login is only available on mobile.',
  'login.pass.toast_login_fail': 'Failed to login. Please try again.',
  'login.splash.title': 'Understanding our child\nAI Report, Onkids',

  'login.agreement.title': 'Please agree to the terms',
  'login.agreement.all': 'I agree to all terms.',
  'login.agreement.age': '[Required] 14 years old or older',
  'login.agreement.service': '[Required] Terms of Service',
  'login.agreement.privacy': '[Required] Privacy Policy',
  'login.agreement.event': '[Optional] Events and benefits',
  'login.agreement.btn_start': 'Agree and start Onkids',
  'login.agreement.btn_disagree': 'Do not agree',
  'login.agreement.error_agree': 'Failed to agree to terms. Please try again.',
  'login.agreement.error_disagree': 'Failed to disagree. Please try again.',

  'login.first_access.skip': 'Skip',
  'login.first_access.name_title': "Please enter\nyour child's name",
  'login.first_access.birth_title': "Please enter\nyour child's birthday",
  'login.first_access.gender_title': "Please enter\nyour child's gender",
  'login.first_access.gender': 'Gender',
  'login.first_access.male': 'Boy',
  'login.first_access.female': 'Girl',
  'login.first_access.birth': 'Birthday',
  'login.first_access.name': 'Name',
  'login.first_access.name_placeholder': "Please enter your child's name",
  'login.first_access.btn_register': 'Register Child',
  'login.first_access.btn_login': 'Go to Login',

  'register.skip': 'Skip',
  'register.name_title': "Please enter\nyour child's name",
  'register.birth_title': "Please enter\nyour child's birthday",
  'register.gender_title': "Please enter\nyour child's gender",
  'register.gender': 'Gender',
  'register.male': 'Boy',
  'register.female': 'Girl',
  'register.birth': 'Birthday',
  'register.name': 'Name',
  'register.name_placeholder': "Please enter your child's name",
  'register.submit': 'Register Child',
  'register.go_to_login': 'Go to Login',
  'register.recording_guide.slide1_1': 'Record within 5 minutes',
  'register.recording_guide.slide1_2': 'Please capture the video',
  'register.recording_guide.slide2_1': 'Ensure only one child',
  'register.recording_guide.slide2_2': 'appears in the video',
  'register.recording_guide.slide3_1': 'Capture expressions,',
  'register.recording_guide.slide3_2': 'gestures, and voices',

  'register_kids.upload.daily_title': 'Daily Video Analysis',
  'register_kids.upload.qna_title': 'Q&A Video Analysis',
  'register_kids.upload.skip': 'Skip',
  'register_kids.upload.daily_main_title': 'For AI talent diagnosis,\nplease upload a video of your child',
  'register_kids.upload.qna_main_title': 'With AI, please let us hear\nyour child’s thoughts',
  'register_kids.upload.daily_sub_title': 'Shall we find your child’s talent right away?',
  'register_kids.upload.qna_sub_title': 'Please only film answering simple questions.',
  'register_kids.upload.guide_btn': 'What kind of video should I film?',
  'register_kids.upload.btn_upload': 'Upload Video',

  // Permissions & Agreements
  'permission.title': 'Please allow access permissions\nto use Onkids.',
  'permission.camera_mic': 'Camera/Microphone',
  'permission.camera_mic_desc': 'Used for video, image shooting, and QR code recognition',
  'permission.storage': 'Storage',
  'permission.storage_desc': 'Needed for saving files and managing app data',
  'permission.location': 'Location',
  'permission.location_desc': 'Used for providing nearby information and services',
  'permission.notification': 'Notification',
  'permission.notification_desc': 'Push notifications and message reception guidance',
  'permission.required': '(Required)',
  'permission.optional': '(Optional)',
  'permission.toast_fail': 'Failed to agree to permissions. Please try again.',

  'agreement.title': 'Please agree to the terms',
  'agreement.all_check': 'I agree to all terms.',
  'agreement.age': '[Required] 14 years old or older',
  'agreement.service': '[Required] Terms of Service',
  'agreement.privacy': '[Required] Privacy Policy',
  'agreement.event': '[Optional] Events and benefits',
  'agreement.submit': 'Agree and start Onkids',
  'agreement.disagree': 'Do not agree',
  'agreement.toast_fail': 'Failed to agree to terms. Please try again.',
  'agreement.toast_disagree_fail': 'Failed to disagree. Please try again.',

  'agreement.age.title': '[Required] I am 14 years of age or older.',
  'agreement.age.content': 'I am 14 years of age or older, and I agree to the collection and use of personal information for using the service of Karainc.\nChildren under the age of 14 require the consent of a legal representative, and service use may be restricted.',
  'agreement.event.title': '[Optional] Receive event and benefit news',
  'agreement.event.content': 'I agree to receive information for marketing purposes.',
  'agreement.event.item1_title': 'Reception Content',
  'agreement.event.item1_desc': 'New product launches, events, benefit guides, customized content information, etc.',
  'agreement.event.item2_title': 'Reception Method',
  'agreement.event.item2_desc': 'Email, text, messenger, etc.',
  'agreement.event.cookie_desc': 'The company may use cookies to analyze users’ service usage patterns and utilize them for providing customized information and remarketing.',
  'agreement.event.cookie_setting': 'Users can allow or refuse cookie installation through browser settings.',
  'agreement.event.no_restriction': 'There is no restriction on service use even if you do not agree.',

  'agreement.privacy.title': '[Required] Privacy Policy',
  'agreement.privacy.content': 'I agree to the privacy policy of Karainc and have understood the contents below.',
  'agreement.privacy.item1_title': 'Rights of Data Subjects',
  'agreement.privacy.item1_desc1': 'Users can request access, correction, or deletion of personal information at any time...',
  'agreement.privacy.item1_desc2': 'When requesting error correction, the information will not be used or provided until completion.',
  'agreement.privacy.item1_desc3': 'Information terminated or deleted according to the user’s request will be processed according to related laws and internal policies.',
  'agreement.privacy.item2_title': 'Video and Sensitive Information Processing',
  'agreement.privacy.item2_desc1': 'Children’s video and non-verbal data are temporarily stored for analysis purposes only...',
  'agreement.privacy.item2_desc2': 'The video is stored in a safe area within the server and cannot be provided externally.',
  'agreement.privacy.item3_title': 'Destruction Procedure and Method',
  'agreement.privacy.item3_desc1': 'Paper printouts: Shredding or incineration',
  'agreement.privacy.item3_desc2': 'Electronic files: Completely deleted in an irrecoverable technical way',
  'agreement.privacy.item3_desc3': 'Information is stored separately after achieving the purpose and destroyed after a certain storage period.',
  'agreement.privacy.item4_title': 'Automatic Collection of Personal Information (Cookies)',
  'agreement.privacy.item4_desc1': 'The company uses cookies to understand users’ interests and usage patterns to provide optimized customized information.',
  'agreement.privacy.item4_desc2': 'Users can block or delete cookies through browser settings.',
  'agreement.privacy.item5_title': 'Security Measures (Technical, Managerial, Physical Protection)',
  'agreement.privacy.item5_desc1': 'Implement protection measures through intrusion blocking systems, access authority management, etc.',
  'agreement.privacy.item5_desc2': 'Grant access authority only to personal information managers, conduct regular security education.',
  'agreement.privacy.item5_desc3': 'Establish access control procedures for storage locations and maintain physical security.',
  'agreement.privacy.item6_title': 'Personal Information Protection Officer',
  'agreement.privacy.item6_desc1': 'Name: Nam Jae-kyu',
  'agreement.privacy.item6_desc2': 'Contact: 070-4633-7412 / klunk@malgum.com',
  'agreement.privacy.footer': '* This privacy policy applies from the effective date.',

  'agreement.service.title': '[Required] Terms of Service',
  'agreement.service.content': 'Karainc collects and uses personal information for purposes such as consultation, consulting operation, providing customized content...',
  'agreement.service.item1_title': 'Collection Items',
  'agreement.service.item1_desc1': 'Required: Name, company name, mobile phone number, email name',
  'agreement.service.item1_desc2': 'Optional: Department, position, industry, phone number, domain owned',
  'agreement.service.item2_title': 'Purpose of Collection',
  'agreement.service.item2_desc1': 'Consultation and consulting operation',
  'agreement.service.item2_desc2': 'Providing customized services such as goods or services, content of your company and partners',
  'agreement.service.item2_desc3': 'PMS registration for project performance',
  'agreement.service.item2_desc4': 'Implementation of contracts regarding service provision, complaint processing, etc.',
  'agreement.service.item3_title': 'Collection Method',
  'agreement.service.item3_desc1': 'Online consultation on the homepage (https://www.karainc.co.kr)',
  'agreement.service.item3_desc2': 'Request for consultation via phone, etc.',
  'agreement.service.item4_title': 'Period of Possession and Use',
  'agreement.service.item4_desc1': 'Destroy without delay when the purpose of collection is achieved or the user withdraws consent...',
  'agreement.service.item5_title': 'Provision to Third Parties',
  'agreement.service.item5_desc1': 'None in principle',
  'agreement.service.item5_desc2': 'Provided only in cases where there is an official request for investigative purposes according to laws.',
  'agreement.service.item6_title': 'User Obligations',
  'agreement.service.item6_desc1': 'Users must not register other people’s personal information or children’s videos without authorization...',
  'agreement.service.item6_desc2': 'This service analysis is based on non-verbal behavior data of children under 14...',
  'agreement.service.footer': '* Details can be found in the [Terms of Service] and [Privacy Policy].',

  'welcome.greeting': 'Nice to meet you, {{name}}!',
  'welcome.title_line1': 'Discover your child’s talent',
  'welcome.title_line2': '',
  'welcome.title_line3': 'We will help you',
  'welcome.toast_success': 'Child registration successful.',
  'welcome.toast_fail': 'Failed to register child.',
  'welcome.parent_default': 'Parent',

  // Home
  'home.register_kid': 'Register Kid',
  'home.register_kid_desc': 'Register your child to use the service',
  'home.male': 'Boy',
  'home.female': 'Girl',
  'home.completed_date': 'Completion Date',
  'home.tip': 'TIP',
  'home.login_signup': 'Sign Up/Login',
  'home.guide.draft.title': "Log in to check your child's potential",
  'home.guide.before.title': 'You can view the report after video analysis!',
  'home.guide.before.desc': 'Upload a video and create a report!',
  'home.guide.completed.title': 'The report is ready! Check it out',
  'home.guide.inProgress.relationship.title': 'Video info on Interpersonal Intelligence is needed!',
  'home.guide.inProgress.relationship.desc': 'Please upload a video of interacting with others',
  'home.guide.inProgress.language.title': 'Video info on Linguistic Intelligence is needed!',
  'home.guide.inProgress.language.desc': 'Please upload a video of talking or answering questions',
  'home.guide.inProgress.math.title': 'Video info on Logical-Mathematical Intelligence is needed!',
  'home.guide.inProgress.math.desc': 'Please upload a video of calculating or memorizing',
  'home.guide.inProgress.physical.title': 'Video info on Bodily-Kinesthetic Intelligence is needed!',
  'home.guide.inProgress.physical.desc': 'Please upload a video of physical activities',
  'home.guide.inProgress.reflection.title': 'Video info on Intrapersonal Intelligence is needed!',
  'home.guide.inProgress.reflection.desc': 'Please upload a video of doing tasks or showing emotions',
  'home.guide.inProgress.nature.title': 'Video info on Naturalist Intelligence is needed!',
  'home.guide.inProgress.nature.desc': 'Please upload a video about animals, plants, or nature',
  'home.guide.inProgress.space.title': 'Video info on Spatial Intelligence is needed!',
  'home.guide.inProgress.space.desc': 'Please upload a video of arranging objects like puzzles or blocks',
  'home.guide.inProgress.music.title': 'Video info on Musical Intelligence is needed!',
  'home.guide.inProgress.music.desc': 'Please upload a video of singing or listening to music',
  'home.select_kid.title': 'Please select a child\nto proceed with video analysis.',
  'home.change_kid.title': 'Change Child',
  'home.change_kid.add_kid': 'Add Child',
  'home.alert.register_kid.title': 'Kid registration is required!',
  'home.alert.register_kid.description': 'AI video analysis is possible after registering a child. Please register a child on the home screen first.',

  'home.analytics.title': 'Discover child talent\nwith AI analysis',
  'home.analytics.mission_soon_title': 'Mission',
  'home.analytics.mission_soon_desc': ' will be opened later.',
  'home.analytics.daily_title': 'Daily video analysis',
  'home.analytics.daily_desc': 'AI observes the daily life',
  'home.analytics.mission_title': 'Mission',
  'home.analytics.mission_desc': 'Parents and children do missions together',
  'home.analytics.qna_title': 'Q&A video analysis',
  'home.analytics.qna_desc': 'AI asks and child answers',

  'home.more_info.community_title': 'Community',
  'home.more_info.onkiz_talk_title': 'Onkids Talk\nSharing stories together',
  'home.more_info.onkiz_talk_desc': 'Parenting and education community',
  'home.more_info.more_onkiz_title': 'Learn more about Onkids',
  'home.more_info.multi_intelligence_title': 'What is Multiple Intelligence?',
  'home.more_info.multi_intelligence_desc': 'Everything about Multiple Intelligence',
  'home.more_info.ai_tech_title': 'Curious about\nOnkids AI technology?',
  'home.more_info.ai_tech_desc': 'Introduction to Onkids AI technology',

  'home.onkiz_ai.title': 'Onkids AI',
  'home.onkiz_ai.intro_title': 'Introduction to Onkids AI',
  'home.onkiz_ai.intro_desc': 'Based on multiple intelligence theory, Onkids analyzes a child’s speech, behavior, and emotional response with AI to discover their strengths and weaknesses. This helps develop the child’s potential and supplement their weaknesses.',
  'home.onkiz_ai.lab_title': 'Onkids AI Research Lab',
  'home.onkiz_ai.lab_desc1': 'Onkids researches and develops multiple intelligence diagnosis services with faculty members of the Sangji University Industry-Academic Cooperation Foundation, experts in gifted and talent education.',
  'home.onkiz_ai.lab_desc2': 'In addition, we hold 6 patents related to AI and solutions. In particular, we have applied for a patent for an image and voice data analysis system to analyze multiple intelligence tendencies.',

  'home.multi_intelligence.title': 'Multiple Intelligence Theory',
  'home.multi_intelligence.intro_title': 'What is Multiple Intelligence Theory?',
  'home.multi_intelligence.intro_desc': 'Multiple Intelligence Theory is proposed by Professor Howard Gardner of Harvard University, viewing human intelligence not as a single ability like IQ or academic grades, but as mutual cooperation between various intelligences.',
  'home.multi_intelligence.feature_title': 'Features of Multiple Intelligence',
  'home.multi_intelligence.feature_1': 'Everyone has 8 types of intelligence',
  'home.multi_intelligence.feature_2': 'All intelligences are equally important',
  'home.multi_intelligence.feature_3': 'The 8 intelligences are independent but work in mutual cooperation',
  'home.multi_intelligence.feature_4': 'Each individual shows a unique profile',
  'home.multi_intelligence.feature_5': 'Development is possible through environment and experience',
  'home.multi_intelligence.feature_6': 'Can strengthen strengths and supplement weaknesses with strengths',
  'home.multi_intelligence.types_title': 'Types of Multiple Intelligence',
  'home.multi_intelligence.type_relationship_desc': 'The ability of people who lead interpersonal relationships well',
  'home.multi_intelligence.type_language_desc': 'The ability to understand and create the world with speaking and writing skills',
  'home.multi_intelligence.type_math_desc': 'The ability to learn and create numbers, rules, propositions, etc.',
  'home.multi_intelligence.type_physical_desc': 'The ability to easily learn and create dance, exercise, acting, etc.',
  'home.multi_intelligence.type_reflection_desc': 'The ability to grasp and express one’s own psychology and emotions',
  'home.multi_intelligence.type_nature_desc': 'The ability to recognize and analyze the environment',
  'home.multi_intelligence.type_space_desc': 'The ability to conceive and create shapes, drawings, maps, solids, etc.',
  'home.multi_intelligence.type_music_desc': 'The ability to easily feel and create notes and beats',

  // Education
  'education.apply_business': 'Apply for Education Business',
  'education.title_line1': 'Get education recommendations',
  'education.title_line2': 'perfect for your child',
  'education.subtitle': 'Customized education for our child explored at a glance',
  'education.get_notified': 'Receive Open Notification',
  'education.alert_title': 'Push Notification Consent',
  'education.alert_desc': 'We will notify you by push notification\nwhen the corresponding page opens later!',

  'upload.daily_title': 'Daily Video Analysis',
  'upload.qna_title': 'Q&A Video Analysis',
  'upload.daily_intro_line1': 'For AI talent diagnosis,',
  'upload.daily_intro_line2': 'please upload a video of your child',
  'upload.qna_intro_line1': 'With AI, please let us hear',
  'upload.qna_intro_line2': 'your child’s thoughts',
  'upload.daily_subtitle': 'Shall we find your child’s talent right away?',
  'upload.qna_subtitle': 'Please only film answering simple questions.',
  'upload.guide_btn': 'What kind of video should I film?',
  'upload.submit_btn': 'Upload Video',
  'upload.guide.title': 'Recording Guide',
  'upload.guide.intro_line1': 'What kind of video',
  'upload.guide.intro_line2': 'should I film?',
  'upload.guide.desc_line1': 'To analyze 8 types of intelligence,',
  'upload.guide.desc_line2': 'please film your child in various situations.',
  'upload.guide.tip': 'Recording Tip',
  'upload.guide.tip_desc1': 'Usually, only 1-2 talents appear in one video.',
  'upload.guide.tip_desc2': 'Try filming various situations to record multiple talents!',
  'upload.caution.title': 'Precautions for Uploading Videos',
  'upload.caution.item1_title': 'Recording',
  'upload.caution.item1_desc': 'Please record the video\nwithin 5 minutes',
  'upload.caution.item2_title': 'Subject',
  'upload.caution.item2_desc': 'A video with only\none child is needed',
  'upload.caution.item3_title': 'Expression',
  'upload.caution.item3_desc': 'Make sure expressions\nand voice are clear',
  'upload.caution.confirm_btn': 'I understand',

  'upload.intelligence_choice.title': 'Select Intelligence for Q&A',
  'upload.intelligence_choice.desc_line1': 'Please select one of the intelligences below.',
  'upload.intelligence_choice.desc_line2': 'We will film a Q&A video with questions matching the selected intelligence.',

  'upload.video_handle.toast_camera_fail': 'Failed to access camera. Please check permissions.',
  'upload.video_handle.toast_stream_not_found': 'Camera stream not found.',
  'upload.video_handle.toast_thumbnail_fail': 'Failed to create thumbnail. Please try again.',
  'upload.video_handle.toast_no_video': 'No video to save.',
  'upload.video_handle.record_btn': 'Record Video',
  'upload.video_handle.gallery_btn': 'Select from Album',
  'upload.video_handle.title': 'Video Recording',
  'upload.video_handle.save_alert_title': 'Video Save Guide',
  'upload.video_handle.save_alert_content': 'The recorded video is currently in a temporary storage state. To save it to your device, please click the [Save] button.',
  'upload.video_handle.save_btn': 'Save',

  'upload.toast_thumbnail_error': 'A problem occurred with the thumbnail. Please press the start diagnosis button again.',
  'upload.select_rep_image': 'Select Representative Image',
  'upload.start_diagnosis_question_line1': 'Shall we start talent diagnosis',
  'upload.start_diagnosis_question_line2': 'with the video below?',
  'upload.rep_image_guide': 'This is an AI auto-recommended scene where the face is clearly visible. Please select 1 thumbnail to use as the representative image.',
  'upload.retake': 'Retake',
  'upload.start_diagnosis': 'Start Diagnosis',
  'upload.character_title': "Target Child's Characteristics",
  'upload.character_desc': 'If there are multiple children in the video, please briefly enter the characteristics of the target child so that AI can accurately analyze it.',
  'upload.character_impression': 'Appearance (Required)',
  'upload.character_impression_placeholder': '(e.g.) Wearing a blue T-shirt',
  'upload.character_physical': 'Physical Characteristics (Optional)',
  'upload.character_physical_placeholder': '(e.g.) Tall',
  'upload.character_behavior': 'Positional/Behavioral Characteristics (Optional)',
  'upload.character_behavior_placeholder': '(e.g.) Left / Sitting at a desk',
  'upload.character_only_one': 'Appears Alone',

  'analysis.standby_title': 'No analysis in progress.',
  'analysis.pending_explore_btn': 'Explore App',
  'analysis.pending_tooltip_line1': 'Do not leave the app during analysis.',
  'analysis.pending_tooltip_line2': 'Other menus can be used freely.',
  'analysis.pending_title_line1': 'AI is analyzing your child’s',
  'analysis.pending_title_line2': 'hidden talent.',
  'analysis.pending_caution': 'Depending on the video, analysis may take at least 5 minutes!',
  'analysis.success_title_line1': 'AI has completed analyzing',
  'analysis.success_title_line2': 'your child’s talent!',
  'analysis.success_best_intelligence': 'Highest Intelligence',
  'analysis.success_top_percent': 'Top {{percent}}%',
  'analysis.success_sub_title': 'Analysis Results by Intelligence',
  'analysis.success_report_btn': 'Check Report',
  'analysis.nothing_title_line1': 'No talent captured',
  'analysis.nothing_title_line2': 'Please upload another video',
  'analysis.error_title_line1': 'Failed to analyze video',
  'analysis.error_title_line2': 'Please check the guide again',
  'analysis.re_upload_btn': 'Re-upload',
  'analysis.status.pending': 'Analyzing',
  'analysis.status.success': 'Analysis Complete',
  'analysis.status.error': 'Analysis Failed',

  // Report
  'report.summary.title': 'Report Summary',
  'report.summary.tooltip': 'You can see the scores and one-line evaluations\nfor excellent and improvable intelligences at a glance.',
  'report.summary.score': '{{score}} pts',
  'report.summary.intelligence': '{{label}} Intelligence',
  'report.summary.desc_high': '{{label}} intelligence is excellent,',
  'report.summary.desc_low': 'and {{label}} intelligence needs improvement.',
  'report.summary.excellent': 'Excellent',
  'report.summary.needs_improvement': 'Needs Improvement',
  'report.summary.comparison_previous_tooltip': 'You can check the intelligences that have\nrisen/fallen the most compared to the previous report.',
  'report.summary.comparison_cumulative_tooltip': 'You can check the intelligences that have\nrisen/fallen the most compared to the average.',
  'report.summary.most_improved': 'Most Improved Intelligence',
  'report.summary.most_decreased': 'Most Decreased Intelligence',
  'report.summary.previous_short': 'Prev',
  'report.summary.current_short': 'Curr',
  'report.summary.average_short': 'Avg',
  'report.growth.title': "Share our child's growth record",
  'report.change_summary.title': 'Change Summary',
  'report.change_summary.tooltip': 'You can check the strongest intelligence\nrecorded for each report.',
  'report.score_analysis.title': "Child's Multi-intelligence Score Analysis",
  'report.change_flow.title': 'Change Trend',
  'report.change_flow.tooltip': 'Press and hold the graph screen and move\nleft/right to check scores between reports.',
  'report.change_flow.empty': 'Less than 2 reports captured this intelligence,\nso the change trend cannot be analyzed.',
  'report.intelligence_rank.title': "Child's Intelligence Rank",
  'report.intelligence_rank.age_group': 'Among children of the same age,',
  'report.intelligence_rank.top_percent': 'Top {{percent}}%',
  'report.intelligence_rank.belong_to': 'in the group.',
  'report.intelligence_rank.kid_label': 'Child',
  'report.intelligence_rank.desc_vhigh': 'Is very excellent among peers.\nResponds quickly to small changes and has high potential.',
  'report.intelligence_rank.desc_high': 'Is excellent among peers.\nCan grow further through active activities.',
  'report.intelligence_rank.desc_middle': 'Is at a similar level to peers.\nA stage of discovering strengths through various experiences.',
  'report.intelligence_rank.desc_low': 'Needs a bit more stimulation and experience.\nParents’ careful observation and support are a great help.',
  'report.intelligence_rank.desc_vlow': 'Is at the stage of laying foundations for development.\nPlease guide slowly according to the child’s pace.',
  'report.core.title': 'Report Highlights',
  'report.core.tooltip': 'Check the AI summary and capture moments\nfor excellent and improvable intelligences.',
  'report.core.more': 'More →',
  'report.core.empty': 'No report highlights.',
  'report.detail.title': 'Detailed Results by Intelligence',
  'report.detail.intelligence_detail_btn': 'Intelligence Detail',
  'report.detail.sub_characteristic_analysis': 'Detailed Characteristic Analysis',
  'report.detail.no_sub_analysis': 'No detailed characteristic analysis.',
  'report.select_intelligence.title': 'Select Intelligence',
  'report.need_more.title': 'Intelligences needing analysis',
  'report.need_more.total_count': '/8 cases',
  'report.video_list.title': 'Uploaded Video List',
  'report.video_list.tooltip': 'In average cases, basic analysis is possible with 7-8 daily videos,\nand if there is insufficient intelligence,\nit can be supplemented with 3-4 Q&A videos.',
  'report.video_list.unit': 'case(s)',
  'report.video_list.completed_intelligence': 'Intelligences with completed analysis',
  'report.video_list.toast_report_delete_fail': 'Failed to delete report. Please try again.',
  'report.video_list.toast_video_delete_fail': 'Failed to delete video. Please try again.',
  'report.video_list.alert_delete_title': 'Report Video Deletion Guide',
  'report.video_list.alert_delete_content': 'Deleted videos and analysis information cannot be recovered.\nAre you sure you want to delete?',
  'report.video_list.alert_delete_success_title': 'Deletion Complete',
  'report.video_list.alert_delete_success_desc': 'Deletion of video and thumbnail has been completed.\nThe report will be updated when a new video is uploaded.',
  'report.video_list.alert_delete_fail_title': 'Deletion is difficult now!',
  'report.video_list.alert_delete_fail_desc': 'Since analysis is currently in progress,\nit is difficult to delete the video being analyzed.\nPlease try again after the current analysis is complete.',
  'report.header.analysis_result': 'Analysis Result',
  'report.header.growth_change': 'Growth Change',
  'report.header.alert_comparison_fail_title': 'Comparison analysis is difficult',
  'report.header.alert_comparison_fail_desc': 'It is difficult to compare growth changes with only one report. Analysis is possible when additional reports are created.',
  'report.header.main_title_suffix': "'s",
  'report.header.main_title_desc': 'Multi-intelligence comprehensive analysis report',
  'report.header.last_modified': 'Last modified',
  'report.header.guide_title': 'Comprehensive Report Production Guide',
  'report.header.guide_desc': 'When all 8 intelligences are captured, your child’s comprehensive report will be completed. Please upload more diverse activity videos!',
  'report.header.insufficient_title': 'Insufficient Number of Captured Intelligences',
  'report.header.insufficient_desc': 'Few intelligences have been captured, so only partial results are shown. For more accurate analysis, please add videos with various activities!',
  'report.header.comparison_previous_result': 'This is the comparison result with the previous report',
  'report.header.comparison_cumulative_result': 'This is the comparison result with the cumulative report',
  'report.radar.title': "Child's strength/weakness intelligence distribution",
  'report.observation.observed': 'Observed',
  'report.observation.not_observed': 'Not Observed',
  'report.presence.exist': 'Exists',
  'report.presence.not_exist': 'Does Not Exist',
  'report.presence.unreadable': 'Unreadable',
  'report.comparison.previous': 'Previous',
  'report.comparison.cumulative': 'Cumulative',
  'report.more.create_new': 'Create New Report',
  'report.more.create_new_guide': '* The existing report will be marked as complete.',
  'report.more.delete': 'Delete Report',
  'report.more.share': 'Share Report',
  'report.more.toast_complete_fail': 'Failed to complete report. Please try again.',
  'report.more.toast_delete_fail': 'Failed to delete report. Please try again.',
  'report.more.alert_complete_title': 'Existing Report Completion Guide',
  'report.more.alert_complete_content': 'If you create a new report,\nthe existing report will be marked as complete.',
  'report.more.alert_delete_title': 'Report Deletion Guide',
  'report.more.alert_delete_content': 'Videos are maintained even if you delete the report.\nVideos can be checked in Growth History.',
  'report.qna.title': 'Ask a Question',
  'report.qna.to_user': 'User',
  'report.qna.to_expert': 'Expert',
  'report.qna.content': 'Content',
  'report.qna.private': 'Private',
  'report.qna.answered': 'Answered',
  'report.qna.not_answered': 'Pending',
  'report.qna.placeholder': 'Please write your content',
  'report.qna.submit': 'Submit',
  'report.qna.toast_submit_fail': 'Failed to submit question.',

  'report.toast.load_fail': 'Failed to load report. Please try again.',
  'report.toast.detail_fail': 'Failed to load report detail. Please try again.',
  'report.toast.previous_fail': 'Failed to load "Previous Comparison" data.',
  'report.toast.cumulative_fail': 'Failed to load "Cumulative Comparison" data.',

  'report.empty_case.title': 'Report unavailable due to insufficient information',

  'report.alert.lack_intelligence_title': 'All intelligences were not captured',
  'report.alert.lack_intelligence_desc': 'Some intelligences were not captured.\nPlease delete videos with duplicate intelligence areas\nand replace them with new videos that can discover uncaptured intelligences.',

  // Community
  'community.event.title': 'Event',
  'community.comment_count': 'Comments {{count}}',
  'community.like': 'Like',
  'community.sort_registration': 'Oldest',
  'community.sort_latest': 'Latest',
  'community.sort_likes': 'Most Liked',
  'community.no_comments': 'No other user answers yet.\nPlease wait a moment.',
  'community.toast_event_load_fail': 'Failed to load event.',
  'community.toast_comment_load_fail': 'Failed to load comments.',
  'community.toast_comment_create_fail': 'Failed to create comment.',
  'community.qna.total': 'Total',
  'community.qna.analysis_report': 'Analysis Report',
  'community.qna.growth_change': 'Growth Change',
  'community.qna.expert': 'Expert',
  'community.qna.question': 'Question',
  'community.qna.user': 'User',
  'community.qna.private_alert_title': 'This is a private post',
  'community.qna.private_alert_desc': 'Private posts can only be viewed by the author',
  'community.qna.expert_answer': 'Expert Answer',
  'community.qna.consultation_guide': '*1:1 consultation with an expert will be updated later.',
  'community.qna.consultation_booking': '1:1 Consultation Booking ({{price}} won)',
  'community.qna.consultation_booking_short': '1:1 Booking',
  'community.qna.private_post': 'This is a private post.',
  'community.qna.toast_load_fail': 'Failed to load post and answer.',
  'community.qna.toast_expert_load_fail': 'Failed to load expert answer.',
  'community.qna.toast_like_fail': 'Failed to register like.',
  'community.complaint.title': 'Report',
  'community.complaint.selector_title': 'Please select the reason for reporting.',
  'community.complaint.placeholder': 'Please enter report details. (min 20, max 300 chars)',
  'community.complaint.submit': 'Report',
  'community.complaint.success_title': 'Report received',
  'community.complaint.success_desc': 'Thank you for reporting.\nWe will review and take action.',
  'community.write.title': 'Title',
  'community.write.content': 'Content',
  'community.write.title_placeholder': 'Please enter a title',
  'community.write.content_placeholder': 'Please enter the content',
  'community.write.qna_placeholder': 'Please enter your inquiry',
  'community.write.submit': 'Submit',
  'community.write.complete': 'Complete',
  'community.write.report': 'Report',
  'community.write.view_date': 'Date',
  'community.write.no_report_selected': 'No report selected',
  'community.write.toast_no_report': 'No report exists. Please create a report.',
  'community.write.toast_report_load_fail': 'Failed to load report. Please try again.',
  'community.write.comparison_previous': 'Previous',
  'community.write.comparison_cumulative': 'Cumulative',
  'community.write.previous_report': 'Previous Report',
  'community.freeboard.title': 'Free Board',
  'community.freeboard.toast_load_fail': 'Failed to load free board list.',
  'community.freeboard.detail_toast_load_fail': 'Failed to load free board data.',
  'community.notice.toast_load_fail': 'Failed to load notice.',
  'community.write_modal.title': 'Select Subject',
  'community.write_modal.freeboard': 'Free Board',
  'community.write_modal.qna': 'Analysis Report Question',
  'community.write_modal.growth': 'Our Child’s Growth Record',

  // History
  'history.favorite.title': 'Favorite Items',
  'history.favorite.more': 'More',
  'history.favorite.empty': 'No favorite videos.',
  'history.favorite.toast_load_fail': 'Failed to load videos. Please try again.',
  'history.all_videos.title': 'View All',
  'history.intelligences.title': 'View by Talent',
  'history.video.intelligence_title': '{{label}} Intelligence',
  'history.video.no_videos': 'No videos.',
  'history.video.toast_favorite_added': 'Video added to favorites.',
  'history.video.toast_favorite_removed': 'Video removed from favorites.',
  'history.video.toast_favorite_fail': 'Failed to process favorite video.',
  'history.video.toast_favorite_error': 'Error processing favorite video.',
  'history.report_core.empty': 'No content.',
  'history.video.favorite': 'Favorite',
  'history.video.share': 'Share',
  'history.video.ai_report': 'AI Report',
  'history.video.share_alert': 'The share function will open later',

  // My Page
  'my.title': 'My Page',
  'my.community': 'Community',
  'my.notice': 'Notice',
  'my.notice.item1_title': 'Guide on Strengthening Privacy and Video Security Policy',
  'my.notice.item2_title': 'Guide on Change of Customer Center Operating Hours',
  'my.notice.item3_title': 'Guide on Precautions When Uploading Videos',
  'my.notice.item4_title': 'Guide on Official Opening of AI Behavior Analysis Report',
  'my.notice.item5_title': 'Guide on Onkids Usage',
  'my.service_info': 'Service Information',
  'my.faq': 'FAQ',
  'my.qna': '1:1 Inquiry',
  'my.qna.private_title': '1:1 Inquiry',
  'my.qna.title_label': 'Title',
  'my.qna.title_placeholder': 'Please enter a title for the inquiry',
  'my.qna.phone_label': 'Phone Number',
  'my.qna.content_label': 'Content',
  'my.qna.content_placeholder': 'Please enter the content of the inquiry',
  'my.qna.submit_btn': 'Submit Inquiry',
  'my.qna.toast_success': '1:1 inquiry has been registered.',
  'my.qna.toast_fail': 'Failed to register 1:1 inquiry. Please try again.',
  'my.my_posts': 'My Posts',
  'my.usage_guide': 'Usage Guide',
  'my.usage.title': 'Usage Guide',
  'my.usage.privacy_title': 'Privacy & Scope',
  'my.usage.item1_title': '1. Collected Personal Information',
  'my.usage.item1_dot1': "Child's name or nickname, age, gender",
  'my.usage.item1_dot2': 'Guardian contact info, email',
  'my.usage.item1_dot3': 'Videos for analysis and report generation info',
  'my.usage.item2_title': '2. Purpose of Collection',
  'my.usage.item2_dot1': 'Providing child intelligence analysis reports',
  'my.usage.item2_dot2': 'Service improvement and statistical usage',
  'my.usage.item2_dot3': 'Report generation and customized content provision',
  'my.usage.item3_title': '3. Scope of Video and Report Disclosure',
  'my.usage.item3_dot1': 'Uploaded videos and reports can only be viewed by the owner (account holder).',
  'my.usage.item3_dot2': 'They are not automatically shared with third parties or disclosed externally.',
  'my.usage.item3_dot3': 'However, they can be viewed by others only if the guardian sets sharing.',
  'my.usage.item4_title': '4. Storage and Retention Policy',
  'my.usage.item4_dot1': 'Videos are automatically deleted within a certain period (e.g., 30 days) after analysis.',
  'my.usage.item4_dot2': 'Reports can be viewed continuously while the account is maintained.',
  'my.usage.item5_title': '5. User Rights',
  'my.usage.item5_dot1': 'Request for access, correction, or deletion of info at any time',
  'my.usage.item5_dot2': 'Deletion requests for videos and reports are reflected immediately',
  'my.usage.item6_title': '6. Security',
  'my.usage.item6_dot1': 'All data is encrypted and stored securely, with technical measures applied to prevent leaks.',
  'my.privacy': 'Privacy & Scope',
  'my.company_info': 'Company Info',
  'my.company.name': 'Kara INC Co., Ltd.',
  'my.company.ceo': 'CEO: Kim Gi-ppeum',
  'my.company.business_number': 'Business Registration Number: 379-88-02450',
  'my.company.address': 'Address: Room 306, Building B, 19 Dapsimni-ro 38-gil, Dongdaemun-gu, Seoul',
  'my.language_settings': 'Language Settings',
  'my.change_language': 'Switch to Korean',
  'my.kids_report.title': 'View Report by Child',
  'my.kids_report.alert_title': 'Go to Analyze Child’s Video',
  'my.kids_report.alert_desc': 'Report viewing is possible after talent analysis.\nWould you like to upload a video and perform talent analysis?',
  'my.kids_report.alert_btn': 'Upload Video',

  // My Posts
  'my.posts.answered': 'Answered',
  'my.posts.no_answer': 'No Answer',
  'my.posts.toast_detail_fail': 'Failed to load data.',
  'my.posts.toast_comment_load_fail': 'Failed to load comments.',
  'my.posts.toast_comment_create_fail': 'Failed to create comment.',
  'my.posts.toast_like_fail': 'Failed to register like.',
  'my.posts.toast_delete_fail': 'Deletion failed.',
  'my.posts.comment_count': 'Comments {{count}}',
  'my.posts.no_comments_line1': "There are no other users' answers yet.",
  'my.posts.no_comments_line2': 'Please wait a little while.',
  'my.posts.qna_answer_empty': 'No answer available.',
  'my.posts.answer': 'Answer',
  'my.posts.toast_load_fail': 'Failed to load the list.',
  'my.posts.user_answer': 'User Answer',

  'my.profile.edit_title': 'Edit Profile',
  'my.profile.parent_edit_title': 'Edit My Profile',
  'my.profile.kid_edit_title': 'Edit Child Profile',
  'my.profile.manage_kids': 'Manage Children',
  'my.profile.parent_title': 'My Profile',
  'my.profile.kid_title': "Child's Profile",
  'my.profile.nickname': 'Nickname',
  'my.profile.name': 'Name',
  'my.profile.birth': 'Birthday',
  'my.profile.gender': 'Gender',
  'my.profile.phone': 'Phone Number',
  'my.profile.email': 'Email',
  'my.profile.delete_kid': 'Delete Child Information',
  'my.profile.save': 'Save',
  'my.profile.toast_img_type_error': 'Only PNG, JPG, JPEG images can be uploaded.',
  'my.profile.toast_img_size_error': 'Please upload an image of 5MB or less.',
  'my.profile.toast_save_success': 'Saved successfully.',
  'my.profile.toast_save_fail': 'Failed to save. Please try again.',
  'my.profile.toast_nickname_required': 'Please enter a nickname.',
  'my.profile.toast_edit_fail': 'Failed to edit profile. Please try again.',
  'my.profile.toast_kid_name_required': 'Please enter child’s name.',
  'my.profile.toast_kid_edit_fail': 'Failed to edit child profile.',
  'my.profile.toast_delete_analysing': 'Deletion is not possible while analyzing the child’s video.',
  'my.profile.select_photo': 'Select Photo File',
  'my.profile.delete_alert_title': 'Child Information Deletion Guide',
  'my.profile.delete_alert_desc': 'Deleting child information will permanently delete all registered videos and analysis report information.\nAre you sure you want to delete?',
  'my.profile.logout': 'Logout',
  'my.profile.signout': 'Withdraw',
  'my.profile.auth_required_title': 'Identity verification is required',
  'my.profile.auth_required_desc': 'Name, date of birth, and mobile phone number can only be modified with identity verification information.',
  'my.profile.auth_guide': 'The above information can be modified after identity verification.',
  'my.profile.logout_confirm_title': 'Do you want to log out?',
  'my.profile.signout_confirm_title': 'Please check before withdrawing.',
  'my.profile.signout_confirm_desc': 'When withdrawing from membership, all information of members and children will be deleted. Do you want to withdraw?',
  'my.profile.info_changed_title': 'Member information has been changed',
  'my.profile.info_changed_desc': 'Member information has been changed to verified information.',
  'my.profile.toast_signout_fail': 'Failed to withdraw membership. Please try again.',
  'my.faq.device_title': 'Which device should I use for recording?',
  'my.faq.device_desc': 'Onkids video recording is fully possible with just a smartphone. Expensive cameras or professional equipment are not necessary. The most important thing is an environment where the child’s expressions and actions are clearly visible.',
  'my.faq.device_tip_title': '※ Recording Tip:',
  'my.faq.device_tip_1': 'Please record in a bright and quiet room.',
  'my.faq.device_tip_2': 'Fix the camera horizontally and be careful not to shake.',
  'my.faq.device_tip_3': 'It is good if the front or slightly side view is captured naturally.',
  'my.faq.device_tip_4': 'A video length of 30 seconds to 3 minutes is appropriate.',
  'my.faq.device_footer': 'It is more important whether analyzable behavior was well captured than the video quality.',
  'my.faq.duration_title': 'How long does report analysis take?',
  'my.faq.duration_desc1': 'After the video upload is complete, the report is automatically generated within an average of 2-3 minutes. Analysis time may vary slightly depending on the length, quality, and upload server status of the video.',
  'my.faq.duration_desc2': 'When analysis is complete, you can immediately check it at [My Page > View Report by Child].',
  'my.faq.title': 'FAQ',
  'my.faq.question_suffix': ',',
  'my.faq.what_curious': 'What are you curious about?',

  // Talents
  'talent.language': 'Linguistic',
  'talent.music': 'Musical',
  'talent.physical': 'Physical',
  'talent.math': 'Logical',
  'talent.space': 'Spatial',
  'talent.relationship': 'Interpersonal',
  'talent.reflection': 'Intrapersonal',
  'talent.nature': 'Naturalist',
  'talent.language.q1': "Tell me your favorite fairy tale.\nWhat's it about?",
  'talent.language.q2': 'Can you make a short story using\nice cream, amusement park, and bicycle?',
  'talent.language.q3': 'In Heungbu and Nolbu,\nwhy did Nolbu break\nthe swallow\'s leg?',
  'talent.music.q1': 'Please sing your favorite song.',
  'talent.music.q2': 'If you made a song,\nwhat instruments would you use?\nYou can pick several.',
  'talent.music.q3': 'Can you sing "Twinkle Twinkle Little Star"\nfast and then slow?',
  'talent.music.q4': 'Teach your favorite song\nto Mom/Dad so they\ncan learn it too.',
  'talent.physical.q1': 'What sports do you like?\nCan you show me one of\nyour favorite moves?',
  'talent.physical.q2': 'Can you mimic a friend\'s or\nteacher\'s expression?\nMaybe with gestures too?',
  'talent.physical.q3': '1. Step forward\n2. Step aside 3. Jump high',
  'talent.physical.q4': 'Let\'s dance freely.',
  'talent.math.q1': 'Have you ever followed rules\nwhile playing?\nWhat were those rules?',
  'talent.math.q2': 'In what order do you prepare\nfor dinner?',
  'talent.math.q3': 'What can you make with\n3 yogurt bottles, 2 coke cans,\nand 1 box?',
  'talent.space.q1': 'What do you see on the way\nto kindergarten?',
  'talent.space.q2': 'If you had Legos, what would\nyou build? How?',
  'talent.space.q3': 'If you play hide-and-seek here,\nwhere is the best hiding spot?',
  'talent.space.q4': 'Describe how Mom\'s face looks.',
  'talent.relationship.q1': 'If you were Nolbu,\nhow would you treat\nyour brother?',
  'talent.relationship.q2': 'What would you do if\ntwo friends were fighting\non the playground?',
  'talent.relationship.q3': 'Have you ever helped your team\nto win a game or match?',
  'talent.relationship.q4': 'How would you ask\na friend for a favor?',
  'talent.reflection.q1': 'In The Happy Prince,\nhow would you feel if you\nwere the Prince?',
  'talent.reflection.q2': 'Have you ever done something good?\nHow did you feel then?',
  'talent.reflection.q3': 'What effort did you make\nto achieve something\nyou wanted to do?',
  'talent.nature.q1': 'For your favorite animal:\n1. How will you feed it?\n2. How will you play with it?',
  'talent.nature.q2': 'If you had leaves, stones, and twigs,\nwhat could you make with them?',
  'talent.nature.q3': 'Show me how to water a plant.',
  'talent.nature.q4': 'What will the plant look like\nwhen it grows up?',
  'talent.language.desc': 'The ability to express thoughts in words and writing.',
  'talent.music.desc': 'The ability to understand and express musical elements.',
  'talent.physical.desc': 'The ability to express by moving the body precisely.',
  'talent.math.desc': 'The ability to think and reason logically.',
  'talent.space.desc': 'Well expressed by recalling scenes in the mind.',
  'talent.relationship.desc': 'The ability to understand and interact with others.',
  'talent.reflection.desc': 'The ability to understand one’s own emotions and thoughts.',
  'talent.nature.desc': 'The ability to take interest in and explore nature.',

  'talent.language.cat1': 'Vocabulary',
  'talent.language.cat2': 'Logical Speaking',
  'talent.language.cat3': 'Language Fluency',
  'talent.language.cat4': 'Understanding & Explaining',
  'talent.language.cat5': 'Emotional Expression',
  'talent.music.cat1': 'Musical Perception',
  'talent.music.cat2': 'Musical Understanding',
  'talent.music.cat3': 'Musical Creation',
  'talent.music.cat4': 'Musical Reproduction',
  'talent.music.cat5': 'Musical Performance',
  'talent.physical.cat1': 'Body Control',
  'talent.physical.cat2': 'Physical Expression',
  'talent.physical.cat3': 'Agility & Responsiveness',
  'talent.physical.cat4': 'Physical Problem Solving',
  'talent.math.cat1': 'Numbers & Operations',
  'talent.math.cat2': 'Problem Solving',
  'talent.math.cat3': 'Pattern Discovery',
  'talent.math.cat4': 'Concept Application',
  'talent.math.cat5': 'Logical Reasoning',
  'talent.space.cat1': 'Spatial Awareness',
  'talent.space.cat2': '3D Composition',
  'talent.space.cat3': 'Direction & Position',
  'talent.space.cat4': 'Spatial Utilization',
  'talent.space.cat5': 'Creative Visual Expression',
  'talent.relationship.cat1': 'Empathy',
  'talent.relationship.cat2': 'Cooperation',
  'talent.relationship.cat3': 'Conflict Resolution',
  'talent.relationship.cat4': 'Persuasion & Understanding',
  'talent.reflection.cat1': 'Emotional Recognition & Expression',
  'talent.reflection.cat2': 'Self-Directedness',
  'talent.reflection.cat3': 'Self-Understanding',
  'talent.reflection.cat4': 'Self-Reflection',
  'talent.nature.cat1': 'Animal & Plant Care',
  'talent.nature.cat2': 'Nature Exploration Attitude',
  'talent.nature.cat3': 'Environmental Sensitivity',
  'talent.nature.cat4': 'Nature Expression',

  'talent.language.guide': 'Film scenes of talking about books read, having a conversation together, or playing word games.',
  'talent.music.guide': 'It is good to include musical expressions such as singing, playing instruments, or matching rhythms.',
  'talent.physical.guide': 'Record physical activities such as dancing, exercising, or making hand gestures.',
  'talent.math.guide': 'Include activities such as counting numbers, matching puzzles, or finding patterns.',
  'talent.space.guide': 'Film activities utilizing spatial perception such as block building, drawing, or finding paths.',
  'talent.relationship.guide': 'Film scenes of interacting with others such as playing with friends, talking with family, or playing cooperative games.',
  'talent.reflection.guide': 'Record activities such as writing and reading a diary, speaking one’s thoughts, or expressing felt emotions.',
  'talent.nature.guide': 'Include activities of communicating with nature such as observing plants, looking at animals, or checking the weather.',

  // Report Detail Commentary
  'report.detail.definition': 'Definition & Concept',
  'report.detail.behavioral_characteristics': 'Behavioral characteristics seen in {{age}}-year-olds',
  'report.detail.support_method': 'Support methods at home',
  'report.detail.precautions': 'Points to note when nurturing strength intelligence',

  'report.reflection.definition': 'Intrapersonal intelligence is the ability to deeply recognize and understand one’s own emotions, thoughts, beliefs, motivations, and temperament, and to proactively regulate one’s life based on this...',
  'report.reflection.behavior.1': 'Tolerates and enjoys time playing or studying alone well.',
  'report.reflection.behavior.2': 'Accepts one’s own mistakes or failure experiences relatively calmly and takes them as lessons.',
  'report.reflection.behavior.3': 'Sets goals by oneself and shows an attempt to act plannedly.',
  'report.reflection.behavior.4': 'Attempts to express emotions or thoughts in various ways such as writing, drawing, or speaking.',
  'report.reflection.behavior.5': 'Needs to think quietly or have one’s own time, and recovers energy through this.',
  'report.reflection.behavior.6': 'There are cases where one prioritizes one’s own internal judgment or beliefs over others’ evaluations.',
  'report.reflection.behavior.7': 'When there is emotionally difficult work, shows an attempt to organize alone or comfort oneself.',
  'report.reflection.behavior.8': 'Feels guilty when deviating from rules and naturally performs self-reflection.',
  'report.reflection.behavior.9': 'One’s own tastes or preferences are firm, and explains them well to others.',
  'report.reflection.behavior.10': 'Sometimes achieves better results in an autonomous environment rather than competition.',
  'report.reflection.support.1.title': 'Encourage emotion diary and self-expression activities',
  'report.reflection.support.1.desc': 'Help with training to recognize and express one’s emotions through picture diaries, emotion cards, ‘Today’s Me’ records, etc.',
  'report.reflection.support.2.title': 'Respect time to think alone',
  'report.reflection.support.2.desc': 'A child with high self-understanding sometimes organizes oneself through alone time. Please watch over rather than interfere.',
  'report.reflection.support.3.title': 'Self-goal setting activities',
  'report.reflection.support.3.desc': 'Need experiences where the child determines and practices ‘what I want to try this week’, ‘habits I want to build’, etc., by oneself.',
  'report.reflection.support.4.title': 'Accept negative emotions',
  'report.reflection.support.4.desc': 'Acknowledge negative emotions such as sadness, jealousy, disappointment, and shame, and encourage them to be expressed.',
  'report.reflection.support.5.title': 'Provide self-expression opportunities linked with other intelligences',
  'report.reflection.support.5.desc': 'Help to naturally express inner emotions and thoughts through music, art, writing, and physical activities.',
  'report.reflection.support.6.title': 'Provide opportunities for emotional rumination',
  'report.reflection.support.6.desc': 'Cultivate habits to reflect by talking about time looking back on the day, ‘things that were happy today’, ‘things I want to do again’, etc.',
  'report.reflection.precautions': 'Children with high intrapersonal intelligence tend to sensitively recognize their own emotions and thoughts and reflect deeply internally...',

  'report.language.definition': 'Linguistic intelligence is the ability to organize thoughts using words and writing, effectively communicate with others, and understand the world...',
  'report.language.behavior.1': 'Enjoys reading books and tries to read storybooks repeatedly.',
  'report.language.behavior.2': 'Shows curiosity about new words and has a developed vocabulary.',
  'report.language.behavior.3': 'Enjoys wordplay, nursery rhymes, rhythmic sentences, humor, etc.',
  'report.language.behavior.4': 'Often explains one’s own experiences or thoughts to peers or adults verbally.',
  'report.language.behavior.5': 'Has an excellent ability to listen to stories or information and remember and deliver them accurately.',
  'report.language.behavior.6': 'Is interested in creating stories or writing activities.',
  'report.language.behavior.7': 'Expresses emotions verbally and tries to deliver one’s thoughts clearly.',
  'report.language.behavior.8': 'Enjoys word quizzes, riddles, and language games.',
  'report.language.behavior.9': 'Often takes the role of explainer or questioner among friends.',
  'report.language.behavior.10': 'Shows talent in writing expressions as well as spoken language.',
  'report.language.support.1.title': 'Provide a rich language environment',
  'report.language.support.1.desc': 'Share various conversations with your child every day and ask about thoughts and emotions. It is important to listen to what the child said until the end and give appropriate feedback.',
  'report.language.support.2.title': 'Creative language play',
  'report.language.support.2.desc': 'Activities such as word chains, word matching, making short stories, and changing the main character in a fairy tale naturally raise the child’s language ability.',
  'report.language.support.3.title': 'Make writing activities routine',
  'report.language.support.3.desc': 'Often provide light writing experiences such as writing simple diaries or introductory texts about favorite animals or places.',
  'report.language.support.4.title': 'Media utilization guidance',
  'report.language.support.4.desc': 'Beneficial audiobooks, storytelling videos, radio programs, etc., can also stimulate the child’s listening language ability.',
  'report.language.support.5.title': 'Respond to child’s questions with an open attitude',
  'report.language.support.5.desc': 'Children with linguistic intelligence have many questions like “Why?” and “How?”. It is very important for parents not to find it bothersome and actively respond to conversations.',
  'report.language.precautions': 'A child with high linguistic intelligence often expresses their thoughts better than peers through words or writing, and often has excellent vocabulary or story organization skills...',

  'report.music.definition': 'Musical intelligence refers to the ability to perceive musical elements such as pitch, rhythm, timbre, melody, and harmony, and to create, express, and enjoy them...',
  'report.music.behavior.1': 'Remembers the melody of songs well and sings along.',
  'report.music.behavior.2': 'Well distinguishes music with wrong pitch or awkward rhythm.',
  'report.music.behavior.3': 'Naturally hums or sings songs like talking to oneself.',
  'report.music.behavior.4': 'Often taps desks or chairs rhythmically during class.',
  'report.music.behavior.5': 'Responds emotionally when listening to music, and eyes or expressions change.',
  'report.music.behavior.6': 'Enjoys dancing to music and tries to express rhythm with the body.',
  'report.music.behavior.7': 'Repeatedly sings learned songs at home or sings them with variations.',
  'report.music.behavior.8': 'Voluntarily seeks and tries to participate in musical activities (choir, instrument performance, rhythm play, etc.).',
  'report.music.behavior.9': 'Responds sensitively to sounds in the classroom (e.g., bell sound, clock sound, etc.).',
  'report.music.behavior.10': 'Distinguishes and responds particularly well to instrument sounds or natural sounds (water sound, bird sound, etc.).',
  'report.music.support.1.title': 'Listen to music often',
  'report.music.support.1.desc': 'Listen to various genres of music (classical, traditional Korean, jazz, children’s songs, etc.) together and talk about points of appreciation.',
  'report.music.support.2.title': 'Provide musical expression opportunities',
  'report.music.support.2.desc': 'Let them freely handle instruments (piano, ukulele, rhythm instruments, etc.), or induce music activities combined with physical activities such as clapping or scarf dancing.',
  'report.music.support.3.title': 'Lyric creation play',
  'report.music.support.3.desc': 'Stimulate creativity by putting new lyrics to existing melodies or making songs containing family stories.',
  'report.music.support.4.title': 'Sound recognition training in daily life',
  'report.music.support.4.desc': 'Expand sensitivity to sounds through questions like “What sound is this?” or “What kind of feeling is the sound you hear now?”.',
  'report.music.support.5.title': 'Share musical emotions',
  'report.music.support.5.desc': 'Let the child express the emotions felt while listening to music in words, and empathize and share those emotions together.',
  'report.music.support.6.title': 'Rhythm games and singing',
  'report.music.support.6.desc': 'Naturally develop musical sense through playing to follow repetitive and simple rhythms or changing daily conversations into rhythm.',
  'report.music.precautions': 'Children with high musical intelligence are sensitive to sounds, rhythms, and melodies and tend to be immersed in musical activities...',

  'report.space.definition': 'Spatial intelligence is the ability to accurately perceive visual and spatial information and to transform or express it...',
  'report.space.behavior.1': 'Recalls visual images in the mind and sometimes explains them in language.',
  'report.space.behavior.2': 'Is very interested in visual materials such as drawings, photos, maps, and diagrams, and prefers them during learning.',
  'report.space.behavior.3': 'Enjoys art classes or drawing activities, and has an excellent sense of color or shape.',
  'report.space.behavior.4': 'Often daydreams during class or tends to imagine scenes in the mind.',
  'report.space.behavior.5': 'Shows interest and ability in puzzle matching, maze finding, block play, Lego assembly, etc.',
  'report.space.behavior.6': 'Tends to get more information from pictures than text, and understands quickly if explained with visual materials.',
  'report.space.behavior.7': 'Has excellent spatial construction skills and makes and enjoys 3D buildings or structures well.',
  'report.space.behavior.8': 'Likes to doodle on books or worksheets or express visually.',
  'report.space.behavior.9': 'Is quick at finding directions or sense of orientation, and is interested in organizing or arranging objects.',
  'report.space.behavior.10': 'Finds details well even in complex pictures, or easily notices changed points.',
  'report.space.support.1.title': 'Learning using visual materials',
  'report.space.support.1.desc': 'Rather than explaining in words or writing, learning interest and understanding increase if visual materials such as pictures, maps, diagrams, and flashcards are used together.',
  'report.space.support.2.title': 'Support manipulation activities',
  'report.space.support.2.desc': 'Often provide blocks, Legos, puzzles, origami, making paper models, etc.',
  'report.space.support.3.title': 'Activities that stimulate spatial sense',
  'report.space.support.3.desc': 'Develop sense of direction and spatial perception through games such as treasure hunting, pathfinding missions, and simple map drawing.',
  'report.space.support.4.title': 'Drawing picture diaries/storyboards',
  'report.space.support.4.desc': 'If opportunities to express emotions or events visually are provided, emotional expression and language intelligence can also develop together.',
  'report.space.support.5.title': 'Actively support artistic activities',
  'report.space.support.5.desc': 'Steadily provide activities that stimulate visual sense such as museum outings, color play, and following famous paintings.',
  'report.space.support.6.title': 'Parallel sensory integration activities',
  'report.space.support.6.desc': 'Also do plays that require coordination of hands and eyes or balance activities (e.g., throwing a ball, spinning a top) to strengthen proprioception and visual-motor integration skills.',
  'report.space.precautions': 'Just because a child has high spatial intelligence, it is not desirable to judge that all thinking is visually centered just because they draw well or assemble well...',

  'report.relationship.definition': 'Interpersonal intelligence is the ability to sensitively perceive other people’s emotions, motivations, desires, moods, intentions, etc., and to respond appropriately and form smooth relationships...',
  'report.relationship.behavior.1': 'Gets along well with peers and shows a stable appearance in relationships with various friends.',
  'report.relationship.behavior.2': 'Naturally takes on a leader role among friends and becomes the center.',
  'report.relationship.behavior.3': 'Listens to a friend’s worries or problems and gives advice by oneself.',
  'report.relationship.behavior.4': 'Quickly notices a friend’s emotions or moods and has excellent empathy skills.',
  'report.relationship.behavior.5': 'Shows an attitude to adjust through conversation even in conflict situations with friends or siblings.',
  'report.relationship.behavior.6': 'Voluntarily participates in and leads group activities such as clubs, group activities, and play groups.',
  'report.relationship.behavior.7': 'Enjoys teaching and feels pride in activities explaining to or informing friends.',
  'report.relationship.behavior.8': 'Shows an appearance of taking the role of a mediator or mediating others’ positions in group activities.',
  'report.relationship.behavior.9': 'Is popular in group activities and has no difficulty making friends.',
  'report.relationship.behavior.10': 'Social adaptability to new people or situations is fast.',
  'report.relationship.support.1.title': 'Utilization of role play and situation plays',
  'report.relationship.support.1.desc': 'Develop emotion expression and other-understanding skills by reproducing relationships with friends, conflict situations, and cooperative activities through role play.',
  'report.relationship.support.2.title': 'Provide emotion expression opportunities',
  'report.relationship.support.2.desc': 'Practice expressing one’s own emotions and understanding others’ emotions through family emotion card play, sharing what happened today, making a ‘mood thermometer’, etc.',
  'report.relationship.support.3.title': 'Provide joint tasks and cooperative play',
  'report.relationship.support.3.desc': 'Develop cooperation and communication skills through board games and cooperative tasks (puzzle matching, setting up a tent, etc.).',
  'report.relationship.support.4.title': 'Strengthen helping behavior',
  'report.relationship.support.4.desc': 'Provide opportunities for small errands within the family, looking after a younger sibling, helping a friend, etc., and acknowledge them.',
  'report.relationship.support.5.title': 'Conversation about social skills',
  'report.relationship.support.5.desc': 'If you have time to share cases and discuss with parents about ways to make friends and ways to resolve conflicts, social thinking skills improve.',
  'report.relationship.support.6.title': 'Provide volunteering and social activity experiences',
  'report.relationship.support.6.desc': 'Develop pro-social attitudes and empathy skills through simple volunteering activities (e.g., environmental cleanup, sharing activities, etc.).',
  'report.relationship.precautions': 'Children with high interpersonal intelligence are proficient at considering and helping others, but because of this, they may show an attitude of not being able to express their own desires and matching others’ expectations excessively...',

  'report.math.definition': 'Logical-mathematical intelligence is the ability to use numbers effectively, to identify causal relationships or logical patterns, and to reason...',
  'report.math.behavior.1': 'Shows great interest in mathematical calculations such as counting, adding, and subtracting.',
  'report.math.behavior.2': 'Likes to classify objects according to criteria such as color, shape, and size and list them in order.',
  'report.math.behavior.3': 'Often asks “Why is that?” and tries to understand causal relationships.',
  'report.math.behavior.4': 'Enjoys games that require strategic thinking such as chess, Go, puzzles, and board games.',
  'report.math.behavior.5': 'Is curious about the operating principles of machines or toys and observes or tries to disassemble them.',
  'report.math.behavior.6': 'Shows interest in abstract symbols or signs and understands their meaning well.',
  'report.math.behavior.7': 'Is interested in the process of experimenting, measuring, and confirming results.',
  'report.math.behavior.8': 'Quickly acquires computer programming or coding concepts.',
  'report.math.behavior.9': 'Enjoys logical conversations and tries to explain their claims with evidence.',
  'report.math.behavior.10': 'Understands and utilizes measurement concepts such as time, distance, and amount early.',
  'report.math.support.1.title': 'Play that stimulates mathematical thinking',
  'report.math.support.1.desc': 'Let them naturally learn the rules of numbers and forms through dice play, dominoes, pattern blocks, etc.',
  'report.math.support.2.title': 'Scientific inquiry in daily life',
  'report.math.support.2.desc': 'Provide experiences of setting hypotheses and observing in daily life, such as measuring the amount of ingredients when cooking or recording the process of plant growth.',
  'report.math.support.3.title': 'Classification and organization habits',
  'report.math.support.3.desc': 'Develop logical thinking skills through activities such as organizing toys by use or classifying laundry by type.',
  'report.math.support.4.title': 'Encourage strategic games',
  'report.math.support.4.desc': 'Help with training to think of the best move regardless of win or loss through board games with rules.',
  'report.math.support.5.title': 'Utilize coding and problem-solving tools',
  'report.math.support.5.desc': 'Let them experience logical sequences and structures through children’s coding blocks or robot manipulation teaching aids.',
  'report.math.precautions': 'Children with high logical-mathematical intelligence may try to interpret all situations only with causal relationships or logic, so it is important to provide emotional stimulation together...',

  'report.physical.definition': 'Bodily-kinesthetic intelligence is the ability to adjust one’s body parts to express thoughts or emotions, or to make sophisticated objects using hands...',
  'report.physical.behavior.1': 'Very much enjoys active physical play such as running, jumping, and climbing.',
  'report.physical.behavior.2': 'Has talent for moving the body or dancing to music.',
  'report.physical.behavior.3': 'Has good eye-hand coordination and is good at throwing and catching balls.',
  'report.physical.behavior.4': 'Has excellent dexterity in making or assembling something using tools.',
  'report.physical.behavior.5': 'Likes to release energy by moving the body rather than sitting still.',
  'report.physical.behavior.6': 'Quickly acquires exercise skills and sophisticatedly adjusts one’s own body.',
  'report.physical.behavior.7': 'Expresses emotions or situations well with the body through acting or imitating.',
  'report.physical.behavior.8': 'Prefers outdoor activities rather than indoors and shows tireless stamina.',
  'report.physical.behavior.9': 'Has a developed sense of touch and enjoys the process of touching and exploring objects.',
  'report.physical.behavior.10': 'Has an excellent sense of balance and is proficient at walking on a balance beam, riding a kickboard, or a bicycle.',
  'report.physical.support.1.title': 'Various sports experiences',
  'report.physical.support.1.desc': 'Develop gross and fine motor skills evenly through various physical activities such as swimming, taekwondo, soccer, and ballet.',
  'report.physical.support.2.title': 'Experience-centered learning',
  'report.physical.support.2.desc': 'Provide many opportunities to learn by making and manipulating directly rather than learning only by looking with eyes.',
  'report.physical.support.3.title': 'Artistic physical expression',
  'report.physical.support.3.desc': 'Help with creative activities to express one’s emotions with the body through drama play or dance.',
  'report.physical.support.4.title': 'Fine motor development play',
  'report.physical.support.4.desc': 'Develop sophisticated manipulation skills through origami, clay play, sewing play, etc.',
  'report.physical.support.5.title': 'Secure outdoor activity time',
  'report.physical.support.5.desc': 'Create an environment where they can release energy by jumping around freely outside for more than a certain amount of time every day.',
  'report.physical.precautions': 'Children with high bodily-kinesthetic intelligence are easy to be misunderstood as being distracted because they have a lot of activity...',

  'report.nature.definition': 'Naturalist intelligence is the ability to observe, understand, and classify the natural world such as plants, animals, geology, and climate...',
  'report.nature.behavior.1': 'Has a lot of interest in animals and plants and remembers names or features well.',
  'report.nature.behavior.2': 'Is immersed in activities observing insects or plants outdoors.',
  'report.nature.behavior.3': 'Tries to feel friendly and look after animals rather than being afraid of them.',
  'report.nature.behavior.4': 'Responds sensitively to natural phenomena such as changes in seasons, weather, and terrain.',
  'report.nature.behavior.5': 'Recovers energy and feels joy in natural environments such as forests, parks, and the sea.',
  'report.nature.behavior.6': 'Likes reading books or watching documentaries related to nature.',
  'report.nature.behavior.7': 'Has a hobby of collecting and classifying natural objects such as stones, shells, and leaves.',
  'report.nature.behavior.8': 'Worries about environmental pollution or endangered animals and tries to practice.',
  'report.nature.behavior.9': 'Prefers activities in nature such as camping or hiking.',
  'report.nature.behavior.10': 'Shows responsibility in growing plants or vegetable garden activities.',
  'report.nature.support.1.title': 'Provide nature exploration opportunities',
  'report.nature.support.1.desc': 'Often create opportunities to experience nature directly, such as forest experiences, visiting botanical gardens, and zoos every weekend.',
  'report.nature.support.2.title': 'Growing pet animals/plants',
  'report.nature.support.2.desc': 'Help them develop responsibility and empathy for life by looking after a puppy, cat, or a small flower pot directly.',
  'report.nature.support.3.title': 'Nature observation log',
  'report.nature.support.3.desc': 'Encourage activities to observe interested insects or plants and record them in drawings or writing.',
  'report.nature.support.4.title': 'Environmental protection education',
  'report.nature.support.4.desc': 'Guide them to make small practices to protect the Earth’s environment routine, such as recycling and saving energy.',
  'report.nature.support.5.title': 'Natural object art activities',
  'report.nature.support.5.desc': 'Broaden sensitivity with creative activities using natural objects such as pebble painting and leaf collage.',
  'report.nature.precautions': 'Children with high naturalist intelligence can feel stuffiness or stress more greatly in artificial and static spaces of modern society...',
};

export default en;
